import React, { useContext } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { AgendaContext } from '../../contexts/AgendaContext';
import { useTheme } from '@emotion/react';
// Mui components
import { Box, Button, Typography } from '@mui/material';
// Components
import BreadcrumbsGeneric from './BreadcrumbsGeneric';
// Images
import LogoOsde from '../../utils/images/logo.png';
import User from '../../utils/images/user.png';
import LogOut from '../../utils/images/log-out.png';
// Hooks
import { toCamelCaseAllWords } from '../../utils/Hooks/textFormatted';
// ErrorProvider
import { useError } from '../../contexts/ErrorProvider.jsx';

export default function NavBar({ loader }) {
  const location = useLocation();
  const routesWithoutNavbar = ['/prestador/inicio', '/prestador/inicio/'];
  const showNavBar = !routesWithoutNavbar.includes(location.pathname);

  const { prestadorLogueado, logout } = useContext(AgendaContext);

  const { handleError } = useError();

  const theme = useTheme();

  const handleLogout = async (e) => {
    e.preventDefault();
    try {
      await logout();
    } catch (error) {
      handleError({ error: error, description: 'initializeError' });
    }
  };

  const navigate = useNavigate();

  return (
    showNavBar && (
      <Box
        sx={{
          display: 'flex',
          position: 'fixed',
          zIndex: 6,
          width: '100%',
          height: '76px',
          boxShadow: '0px 4px 20px 5px #2023270D',
          padding: '1rem 2rem',
          backgroundColor: theme.palette.white.main
        }}>
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            width: '100%',
            alignItems: 'center'
          }}>
          <Box sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center', gap: '3rem' }}>
            <Box
              component="img"
              sx={{ width: '106px', height: '41px' }}
              alt="img not found"
              src={LogoOsde}
              onClick={() => navigate('/prestador/dashboard')}
            />
            <BreadcrumbsGeneric loader={loader} />
          </Box>

          <Box sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center', gap: '1rem' }}>
            <Box
              sx={{
                width: '2rem',
                height: '2rem',
                borderRadius: '50%',
                backgroundColor: theme.palette.backgroundSecondary.main,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center'
              }}>
              <img src={User} alt="img not found" style={{ width: '1rem' }} />
            </Box>
            {prestadorLogueado && (
              <Typography variant="textLink" component="p">
                {toCamelCaseAllWords(prestadorLogueado.name)}
              </Typography>
            )}

            <Button
              variant="text"
              sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                cursor: 'pointer'
              }}
              onClick={(e) => handleLogout(e)}>
              <img src={LogOut} alt="img not found" style={{ width: '1.5rem' }} />
            </Button>
          </Box>
        </Box>
      </Box>
    )
  );
}
